import { Component } from '@angular/core';

@Component({
    selector: 'discord-icon',
    template: '<img src="/assets/svgs/socials/discord.svg" height=27 width=27>',
    styleUrls: ['../svg.component.scss']
})
export class DiscordIcon {

}